import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  Waves, Sparkles, Dumbbell, Baby, Circle, Bike, Briefcase, Shirt,
  Clock, Wifi, Phone, Siren, Luggage,
} from "lucide-react";
import { PageHeader } from "../components/Shared";
import { translations } from "@/i18n";

const ICONS = { Waves, Sparkles, Dumbbell, Baby, Circle, Bike, Briefcase, Shirt, Clock, Wifi, Phone, Siren, Luggage };
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PromoInfo({ navigate, lang }) {
  const T = translations[lang];
  const [promos, setPromos] = useState([]);

  useEffect(() => {
    fetch(`${API}/promos`)
      .then((r) => (r.ok ? r.json() : []))
      .then(setPromos)
      .catch(() => setPromos([]));
  }, []);

  return (
    <div className="min-h-screen" data-testid="promo-screen">
      <PageHeader title={T.promoTitle} onBack={() => navigate("dashboard")} />

      <div className="px-4 py-5 pb-[100px] space-y-7">
        <section>
          <h2 className="font-playfair font-semibold text-[19px] text-[#1A1A2E] mb-3">{T.secPromo}</h2>
          <div className="space-y-3">
            {promos.map((p, i) => (
              <motion.div
                key={p.id || i}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.06, duration: 0.3 }}
                className="relative bg-gradient-to-br from-[#FFFDF5] to-[#F5E6B8]/40 rounded-[16px] p-4 pt-7 border border-[#EAD89A] shadow-[0_2px_12px_rgba(201,168,76,0.12)]"
                data-testid="promo-card"
              >
                <span className="absolute top-0 left-0 bg-[#C9A84C] text-white text-[10px] font-bold tracking-wider px-3 py-1 rounded-br-[12px] rounded-tl-[16px]">
                  PROMO
                </span>
                <h3 className="font-inter font-semibold text-[15px] text-[#1A1A2E]">{p.emoji} {lang === "en" ? p.title_en : p.title_id}</h3>
                <p className="text-[13px] text-[#6B7B8D] mt-1.5 leading-relaxed">{lang === "en" ? p.desc_en : p.desc_id}</p>
              </motion.div>
            ))}
          </div>
        </section>

        <section>
          <h2 className="font-playfair font-semibold text-[19px] text-[#1A1A2E] mb-3">{T.secFacilities}</h2>
          <div className="grid grid-cols-2 gap-3">
            {T.facilities.map((f, i) => {
              const Icon = ICONS[f.icon];
              return (
                <div key={i} className="bg-white rounded-[14px] p-4 flex flex-col gap-2 shadow-[0_2px_12px_rgba(74,173,223,0.06)] border border-[#F0F7FF]">
                  <Icon size={24} className="text-[#4AADDF]" />
                  <span className="text-[13px] text-[#1A1A2E] font-medium leading-tight">{f.label}</span>
                </div>
              );
            })}
          </div>
        </section>

        <section>
          <h2 className="font-playfair font-semibold text-[19px] text-[#1A1A2E] mb-3">{T.secInfo}</h2>
          <div className="bg-white rounded-[16px] shadow-[0_2px_12px_rgba(74,173,223,0.08)] border border-[#F0F7FF] divide-y divide-[#F0F7FF]">
            {T.importantInfo.map((info, i) => {
              const Icon = ICONS[info.icon];
              return (
                <div key={i} className="flex items-center gap-3 px-4 py-3.5">
                  <div className="w-9 h-9 rounded-full bg-[#E8F4FD] flex items-center justify-center shrink-0">
                    <Icon size={18} className="text-[#4AADDF]" />
                  </div>
                  <span className="text-[14px] text-[#1A1A2E]">{info.text}</span>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
}
